// extracted by mini-css-extract-plugin
export default {"wrapper":"ProgressBar_wrapper__hLZEJ","logo":"ProgressBar_logo__Fz5CQ","backButton":"ProgressBar_backButton__PaefY","progress":"ProgressBar_progress__SL7FS"};